import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';
import * as React from 'react';
import { twMerge } from 'tailwind-merge';

export const Collapsible = React.forwardRef<
  React.ComponentRef<typeof CollapsiblePrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CollapsiblePrimitive.Root>
>(({ className, ...props }, ref) => (
  <CollapsiblePrimitive.Root
    className={twMerge('flex w-full flex-col', className)}
    ref={ref}
    {...props}
  />
));
Collapsible.displayName = CollapsiblePrimitive.Root.displayName;

export const CollapsibleTrigger = React.forwardRef<
  React.ComponentRef<typeof CollapsiblePrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof CollapsiblePrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <CollapsiblePrimitive.Trigger
    className={twMerge(
      'group shrink-0 border-0 bg-transparent p-0 [&[data-state=closed]>svg]:-rotate-90 [&_svg]:transition-transform [&_svg]:duration-300 [&_svg]:ease-out',
      className,
    )}
    ref={ref}
    {...props}
  />
));
CollapsibleTrigger.displayName = CollapsiblePrimitive.Trigger.displayName;

export const CollapsibleContent = React.forwardRef<
  React.ComponentRef<typeof CollapsiblePrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof CollapsiblePrimitive.Content>
>(({ className, children, ...props }, ref) => (
  <CollapsiblePrimitive.Content
    className="overflow-hidden text-sm data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down"
    ref={ref}
    {...props}
  >
    <div className={className}>{children}</div>
  </CollapsiblePrimitive.Content>
));
CollapsibleContent.displayName = CollapsiblePrimitive.Content.displayName;
